/**
 * Prompt templates — each has a key, icon name (lucide-react), and i18n keys
 * for label and scaffold text.
 */
const templates = [
  { key: 'summarize', icon: 'FileText' },
  { key: 'explain', icon: 'BookOpen' },
  { key: 'brainstorm', icon: 'Lightbulb' },
  { key: 'analyze', icon: 'BarChart3' },
  { key: 'compare', icon: 'GitCompareArrows' },
];

export default templates;
